import { Fragment } from "react";
import { useNavigate } from 'react-router-dom';
import { Primary } from "../../buttons/navigation/Primary";
import { Menu, Transition } from "@headlessui/react";
import {
  ChevronDownIcon,
  ChevronRightIcon,
  ArrowLeftOnRectangleIcon,
} from "@heroicons/react/24/outline";
import { navLogin } from "../options/MenuOptions";
import { closeSession } from '../../../utils/closeSession';

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

export default function MyCount(props) {
  const navigate = useNavigate();
  const handleCloseSession = () => {
    closeSession();
    navigate('/ingresar');
  }
  return (
    <Menu as="div" className="relative text-tdark">
      <div>
        <div>
          <Menu.Button as="div" className="h-full">
            <Primary
              text="Mi cuenta"
              icon={<ChevronDownIcon className="w-4 h-4" />}
            />
          </Menu.Button>
        </div>
      </div>
      <Transition
        as={Fragment}
        enter="transition ease-out duration-200"
        enterFrom="transform opacity-0 scale-95"
        enterTo="transform opacity-100 scale-100"
        leave="transition ease-in duration-75"
        leaveFrom="transform opacity-100 scale-100"
        leaveTo="transform opacity-0 scale-95"
      >
        <Menu.Items className="origin-top-right absolute right-0 mt-2 w-52 rounded-md shadow-lg py-1 bg-white ring-1 ring-red/5 focus:outline-hidden">
          <Menu.Item>
            {({ active }) => (
              <div
                className={classNames(active ? "bg-white" : "", "text-sm")}
              >
                <div>
                  <div className="flex rounded-t px-4 py-2 text-lg font-bold bg-tdark text-white">
                    <span>Hola, {props.name}</span>
                    <div className="grid content-end pb-0.5">
                      <ChevronRightIcon className="w-5 h-auto" />
                    </div>
                  </div>
                  <div className="px-4 py-2">
                    {navLogin.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className="block py-2 hover:font-bold"
                      >
                        {item.name}
                      </a>
                    ))}
                    <hr className="mt-4 text-purple/40" />
                    <button
                      type="button"
                      onClick={handleCloseSession}
                      className="flex py-2 hover:font-bold"
                    >
                      <ArrowLeftOnRectangleIcon className="w-4 h-auto" />
                      <span className="ml-2">Cerrar sesión</span>
                    </button>
                  </div>
                </div>
              </div>
            )}
          </Menu.Item>
        </Menu.Items>
      </Transition>
    </Menu>
  );
}
